<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors }"
    :mode="validateMode"
    :vid="formControlId"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :error="errors[0]"
      :loading="loading"
      :normal-label="normalLabel"
    >
      <div class="vvs-uploader">
        <div class="vvs-uploader__upload-file">
          <label
            :for="formControlId"
            class="vvs-uploader__upload-file__label"
          ></label>
          <div
            class="vvs-uploader__upload-file__text"
            :class="{ 'vvs-uploader__upload-file__text--error': errors[0] }"
          >
            SEÇİN
          </div>
          <input
            :id="formControlId"
            ref="mediaFile"
            type="file"
            class="vvs-uploader__upload-file__file"
            title="Tıklayarak dosya seçebilir veya dosyayı üzerine sürükle-bırak yapabilirsiniz"
            :accept="accept"
            :multiple="multiple"
            @change="handleUploadMedia"
          />
        </div>
        <div class="vvs-uploader__uploaded-files">
          <div
            class="vvs-uploader__uploaded-files__file"
            v-for="(media, index) in mediaUrls.files"
            :key="index"
          >
            <a
              :href="media.url"
              target="_blank"
              class="vvs-uploader__uploaded-files__file__link"
            >
              <img
                :src="media.thumb"
                alt=""
                class="vvs-uploader__uploaded-files__file__link__image"
              />
            </a>
            <p
              class="vvs-uploader__uploaded-files__file__remove-button"
              @click="removeMedia({ mediaIndex: media.index })"
            >
              X KALDIR
            </p>
          </div>
          <div
            v-if="mediaUrls.count > 3"
            class="vvs-uploader__uploaded-files__file--more"
          >
            (+{{ mediaUrls.count - 3 }} daha)
          </div>
        </div>
      </div>

      <input type="hidden" :value="proxy" />
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsUplaoder',
  mixins: [formControlMixin],
  props: {
    accept: {
      type: String,
      default: 'image/jpeg,image/png,application/pdf',
    },
    acceptText: {
      type: String,
      default: 'jpeg, jpg, png veya pdf',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    mediaUrls() {
      return {
        files: this.proxy
          .map((media, index) => {
            const thumb =
              media.contentType === 'application/pdf'
                ? require('@/assets/images/pdf_icon.png')
                : this.getMediaUrl({ media, usePath: 'secureProfilePath' });

            return {
              index,
              url: this.getMediaUrl({ media }),
              thumb,
            };
          })
          .reverse()
          .splice(0, 3),
        count: this.proxy.length,
      };
    },
  },
  methods: {
    async handleUploadMedia(event) {
      const files = Array.from(
        event.target['files'] || event.dataTransfer.files
      );

      this.$refs.mediaFile.value = null;

      if (this.checkMimeType({ files })) {
        await this.$store.commit('setIsAppLoading', true);
        await this.$store
          .dispatch('management/uploadMedias', {
            file: files[0],
          })
          .then(response => {
            if (response) {
              this.proxy.push(response);
              this.$nextTick(this.onInput);
              this.$notify({
                title: 'Yükleme Başarılı',
                text: `${this.name} dosyası başarıyla yüklendi`,
                type: 'success',
              });
            } else {
              this.$notify({
                title: 'Yükleme Başarısız',
                text: `${this.name} dosyası yüklenemedi`,
                type: 'danger',
              });
            }
          });
        await this.$store.commit('setIsAppLoading', false);
      }
    },
    removeMedia({ mediaIndex }) {
      this.$store.commit('setIsAppLoading', true);

      setTimeout(() => {
        this.proxy.splice(mediaIndex, 1);
        this.$nextTick(this.onInput);
        this.$store.commit('setIsAppLoading', false);
        this.$notify({
          title: 'Dosya Silindi',
          text: `${this.name} dosyası başarıyla silindi`,
          type: 'success',
        });
      }, 500);
    },
    checkMimeType({ files = null }) {
      const { type } = files[0];
      const isValid = !!type && this.accept.indexOf(type) > -1;

      if (!isValid) {
        this.$dialog.alert(
          {
            title: 'Hatalı Dosya Seçimi',
            body: `Geçersiz bir dosya seçtiniz.<br>Yüklenen dosyalar ${this.acceptText} uzantılı olmalıdır.`,
          },
          { okText: 'Tamam' }
        );
      }

      return isValid;
    },
  },
};
</script>
